import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box, Container, Typography } from '@mui/material';

import { useErrorToMessageData } from 'pages/ErrorPage/useErrorToMessageData';

import { ReactComponent as Logo } from 'assets/icons/LogoWithoutText.svg';

import { Button } from 'components/_basic/Button/Button';
import { ContentWrapper } from 'components/_basic/ContentWrapper/ContentWrapper';

import { IErrorBoundaryFallbackComponent } from './types';

import styles from './ErrorBoundaryFallbackComponent.module.scss';

export const ErrorBoundaryFallbackComponent: FC<IErrorBoundaryFallbackComponent> = ({ authenticated }) => {
  const navigate = useNavigate();

  const {
    heading,
    text,
    button: { btnText, path },
  } = useErrorToMessageData();

  const handleClick = () => navigate(path);

  return (
    <Container className={styles.wrapper}>
      <ContentWrapper className={styles.container}>
        <Box>
          <Logo />
        </Box>
        <Box className={styles.messageContainer}>
          <Typography variant="h3">{heading}</Typography>
          <Typography className={styles.body} variant="body1">
            {text}
          </Typography>
          {authenticated && (
            <Button className={styles.button} color="primary" variant="contained" onClick={handleClick}>
              {btnText}
            </Button>
          )}
        </Box>
      </ContentWrapper>
    </Container>
  );
};
